module.exports = __webpack_public_path__ + "static/mariamwbg-2643f3426eed8170c42b08a2e7956ab2.png";